import {createAuthClient} from 'better-auth/react';
import type {BetterAuthSession, BetterAuthUser} from '@api/auth';
import {DEV_API_URL} from '@common/constants/network';

const getApiUrl = () => {
  if (typeof window === 'undefined') return DEV_API_URL;

  const hostname = window.location.hostname;
  if (import.meta.env.VITE_API_URL && hostname.includes('cbs-infinity.com')) {
    return import.meta.env.VITE_API_URL;
  }
  if (hostname === 'localhost') return DEV_API_URL;
  if (hostname.includes('192.168.')) return DEV_API_URL;
  if (hostname.includes('127.')) return DEV_API_URL;
  if (!hostname.includes('cbs-infinity.com')) {
    // Custom domains use CloudFront API proxy — same-origin
    return window.location.origin;
  }
  return 'https://api.cbs-infinity.com';
};

export const authClient = createAuthClient({
  basePath: '/api/auth',
  baseURL: getApiUrl(),
  fetchOptions: {
    credentials: 'include',
  },
});

export type Session = BetterAuthSession;
export type User = BetterAuthUser;
